import { createContext } from 'react';
export default createContext({});
//# sourceMappingURL=menuContext.js.map